import { jsx } from 'react/jsx-runtime';
import { useMergedCSS } from '@flex-design-system/stitches-react';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { forwardRef, useState, useLayoutEffect } from 'react';
import usePopperPresence from '../../../../hooks/usePopperPresence.mjs';
import { Legacy_Dropdown } from '../../../legacy-dropdown/Dropdown.mjs';
import useOptionObserver from '../../hooks/useOptionCount.mjs';
import { useSelectContext, useSelectSearchContext, Collection } from '../context.mjs';

const DEFAULT_OPTION_COUNT_STATE = -1;
const SelectContentImpl = forwardRef(
  (props, ref) => {
    const {
      children,
      align = "start",
      affix,
      zIndex,
      css: cssFromProps,
      ...restProps
    } = props;
    const { open, value, hasEmptyView, onClose } = useSelectContext();
    const { onRenderEmptyChange, renderEmpty } = useSelectSearchContext();
    const [contentElement, setContentElement] = useState(null);
    const { ref: presenceRef } = usePopperPresence({
      open,
      onPresenceChange: (isPresent) => !isPresent && onClose?.()
    });
    const composedRef = useComposedRefs(
      ref,
      presenceRef,
      (element) => setContentElement(element)
    );
    const optionCount = useOptionObserver(contentElement, {
      fallbackState: DEFAULT_OPTION_COUNT_STATE
    });
    useLayoutEffect(() => {
      if (open && optionCount !== DEFAULT_OPTION_COUNT_STATE) {
        onRenderEmptyChange(optionCount === 0);
      }
    }, [onRenderEmptyChange, optionCount, open]);
    const nothingToDraw = renderEmpty && !hasEmptyView;
    const css = useMergedCSS(
      cssFromProps,
      nothingToDraw ? {
        py: 0
      } : void 0
    );
    return /* @__PURE__ */ jsx(
      Legacy_Dropdown.Content,
      {
        ...restProps,
        css,
        affix,
        align,
        role: "listbox",
        zIndex,
        ref: composedRef,
        children: /* @__PURE__ */ jsx(Legacy_Dropdown.RadioGroup, { value: `${value}`, children: /* @__PURE__ */ jsx("div", { children }) })
      }
    );
  }
);
const SelectContent = forwardRef(
  (props, ref) => {
    const { children, ...restProps } = props;
    return /* @__PURE__ */ jsx(Collection.Provider, { scope: void 0, children: /* @__PURE__ */ jsx(Collection.Slot, { scope: void 0, children: /* @__PURE__ */ jsx(SelectContentImpl, { ...restProps, role: "listbox", ref, children }) }) });
  }
);

export { SelectContent };
//# sourceMappingURL=Content.mjs.map
